import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Check } from "lucide-react";
import api, { inr } from "../lib/api";

export default function OrderConfirmation() {
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    api.get(`/orders/${orderId}`).then((r) => setOrder(r.data)).catch(() => {});
  }, [orderId]);

  return (
    <div className="pt-20 min-h-screen" data-testid="order-confirmation">
      <div className="px-5 md:px-10 max-w-[900px] mx-auto pt-24 pb-28 text-center">
        <motion.div initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ type: "spring", stiffness: 200, damping: 15 }} className="mx-auto grid h-20 w-20 place-items-center rounded-full bg-ink text-ivory mb-8">
          <Check size={32} />
        </motion.div>
        <p className="overline text-gold-deep mb-4">Thank you</p>
        <h1 className="font-serif text-5xl md:text-7xl tracking-tight mb-6">Your order is confirmed</h1>
        <p className="text-ink-soft mb-2">Order reference</p>
        <p className="mono text-sm mb-12">{orderId}</p>

        {order && (
          <div className="text-left border border-line divide-y divide-line max-w-2xl mx-auto">
            {order.items.map((i, idx) => (
              <div key={idx} className="flex items-center gap-4 p-4">
                <img src={i.image} alt={i.name} className="h-20 w-16 object-cover bg-[#efece6]" />
                <div className="flex-1">
                  <p className="font-serif text-xl">{i.name}</p>
                  <p className="overline text-ink-soft mt-1">Size {i.size} · Qty {i.quantity}</p>
                </div>
                <span className="text-sm">{inr(i.price * i.quantity)}</span>
              </div>
            ))}
            <div className="flex justify-between p-4">
              <span className="font-serif text-2xl">Total</span>
              <span className="font-serif text-2xl">{inr(order.total)}</span>
            </div>
          </div>
        )}

        <div className="mt-12 flex items-center justify-center gap-4">
          <Link to="/account" className="btn-outline px-8 py-3.5 overline">View my orders</Link>
          <Link to="/shop" className="btn-ink px-8 py-3.5 overline">Continue shopping</Link>
        </div>
      </div>
    </div>
  );
}
